module.exports = __webpack_public_path__ + "img/beecbe4.png";